class SelectionManager {
	private selectedItems: number[];
	private allItems: number[];

	public selectItems(newIndex: number, lastItemIndex: number | null): void {
		const { min, max } = this.getMinMaxItemsIndex(newIndex, lastItemIndex);

		for (let i = min; i <= max; i++) {
			this.addItem(this.allItems[i]);
		}
	}

	public deselectItems(lastShiftIndex: number | null, lastItemIndex: number | null): void {
		const { min, max } = this.getMinMaxItemsIndex(lastShiftIndex, lastItemIndex);

		for (let i = min; i <= max; i++) {
			this.removeItem(this.allItems[i]);
		}
	}

	public set(selectedItems: number[], allItems: number[]): void {
		this.selectedItems = selectedItems;
		this.allItems = allItems;
	}

	public get(): number[] {
		return this.selectedItems;
	}

	public isGapInSelectedItems(items: number[]): boolean {
		let isGap = false;

		for (let i = 0; i < items.length; i += 1) {
			if (items[i + 1] - items[i] > 1) {
				isGap = true;
				break;
			}
		}

		return isGap;
	}

	private addItem(item: number): void {
		if (!this.selectedItems.includes(item)) {
			this.selectedItems.push(item);
		}
	}

	private removeItem(item: number): void {
		const index = this.selectedItems.indexOf(item);
		this.selectedItems.splice(index, 1);
	}

	private getMinMax(a: number, b: number): { min: number, max: number } {
		return {
			min: Math.min(a, b),
			max: Math.max(a, b),
		};
	}

	private getIndex(item: number | null): number {
		return item ? this.allItems.indexOf(item) : -1;
	}

	private getMinMaxItemsIndex(a: number | null, b: number | null): { min: number, max: number } {
		return this.getMinMax(this.getIndex(a), this.getIndex(b));
	}
}

export default new SelectionManager();



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/selectionManager.ts